import { TMetaPrimitives } from '@cian/logger/shared';
import { prepareOffer } from 'shared/mappers/prepareOffer';
import {
  fetchSearchOffersMobileSite,
  TSearchOffersMobileSiteRequest,
  TSearchOffersMobileSiteResponse,
} from 'shared/repositories/search-engine/v1/search-offers-mobile-site';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TOffer } from 'shared/types/offer';

type TFetchOffersParameters = TSearchOffersMobileSiteRequest & {
  limit: number;
};

export async function fetchOffers(
  { logger, httpApi, config }: IApplicationContext,
  { limit, ...parameters }: TFetchOffersParameters,
): Promise<TOffer[]> {
  try {
    const result: TSearchOffersMobileSiteResponse = await fetchSearchOffersMobileSite({
      httpApi,
      parameters,
    });

    if (result.statusCode !== 200) {
      logger.warning(result.response.message || /* istanbul ignore next */ 'Код ответа не 200', {
        domain: 'src/shared/services/fetchOffers.ts [fetchOffers]',
        message: 'Не удалось получить список офферов',
        errors: result.response.errors as unknown as TMetaPrimitives[],
      });

      return [];
    }

    const { offers } = result.response;

    return offers.slice(0, limit).map(offer => prepareOffer(offer, config));
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchOffers.ts [fetchOffers]',
      message: 'Не удалось получить список офферов',
    });

    throw error;
  }
}
